export function daysInMonth (month, year) {
    return new Date(year, month, 0).getDate();
}

export function getMonthsAndDays (year = null) {
    const monthsAndDays = [
        { index: 1, month: "Jan", days: 31 },
        { index: 2, month: "Feb", days: isLeapYear(year) ? 29 : 28 }, // 29 in a leap year
        { index: 3, month: "Mar", days: 31 },
        { index: 4, month: "Apr", days: 30 },
        { index: 5, month: "May", days: 31 },
        { index: 6, month: "Jun", days: 30 },
        { index: 7, month: "Jul", days: 31 },
        { index: 8, month: "Aug", days: 31 },
        { index: 9, month: "Sep", days: 30 },
        { index: 10, month: "Oct", days: 31 },
        { index: 11, month: "Nov", days: 30 },
        { index: 12, month: "Dec", days: 31 }
      ];
    
    return monthsAndDays;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
}
  

export function getYearList () {
    const currentYearMinus18 = new Date().getFullYear() - 18;
    const fiftyYearsBack = currentYearMinus18 - 50;
    let yearList = [];

    for (let index = currentYearMinus18; index > fiftyYearsBack; index--) {
        yearList.push(index)
    }

    return yearList;
}